import { render } from "./Spinner.vue?vue&type=template&id=31e0fe64&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=31e0fe64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31e0fe64"

export default script